module.exports = __webpack_public_path__ + "img/logosseu.1dcb6fb5.svg";